"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tupleNum = exports.tuple = void 0;
// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
exports.tuple = (...args) => args;
exports.tupleNum = (...args) => args;
